query linkLogEntries($scenarioId: ID!, $originId: ID!, $filter: LinkLogEntryFilterInput) {
  data(scenarioId: $scenarioId, originId: $originId) {
    linkLogEntry(filter: $filter) {
      items {
        id
        date
        resource
        link {
          id
          code
          enabled
          __typename
        }
        objectId
        changeType
        change
        user {
          id
          username
          name
          __typename
        }
        __typename
      }
      pageInfo {
        page
        size
        total
        __typename
      }
      __typename
    }
    __typename
  }
}
